import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlBundle } from '../../../models/urlBundle';
import { UrlProviderService } from '../../../services/url.provider';

@Component({
  selector: 'eid-unsupported-country-us-mobile',
  templateUrl: './unsupported-country-us.mobile.component.html',
  styleUrls: ['./unsupported-country-us.mobile.component.scss']
})
export class UnsupportedCountryUSMobileComponent {
  public urlBundle$: Observable<UrlBundle>;

  constructor(private urlProviderService: UrlProviderService) {
    this.urlBundle$ = this.urlProviderService.urlBundle$;
  }
}
